import {createApp, nextTick} from 'vue';
import store from '@/store'

import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes'
import { isNativeApp } from '@/utils/nativeApp'
import { appStartRoute } from '@/layout/appTabs'

const SIGN_IN_ROUTES = ['login', 'two-factor-auth', 'two-factor-setup']

const routeMiddleware = resolveMiddleware(
  import.meta.glob('./middleware/*.js', { eager: true })
)
const router = make()

// sync(store, router)

export default router

/**
 * Create a new router instance.
 *
 * @return {Router}
 */
function make () {
  const router = createRouter({
    history: createWebHistory(),
    scrollBehavior,
    routes: routes.map(beforeEnter) // same behavior
  })

  // Register before guard.
  router.beforeEach(async (to, from, next) => {
    //await setLocale(store.getters['lang/locale'])

    if (!store.getters['auth/check'] && store.getters['auth/token']) {
      try {
        await store.dispatch('auth/fetchUser')
      } catch (e) { }
    }

    // The Android app opens in its first tab, at start and after signing in; the home page is on its "More" tab
    if (isNativeApp && to.name === 'home' && store.getters['auth/check'] && (!from.name || SIGN_IN_ROUTES.includes(from.name))) {
      return next(appStartRoute(store.getters['auth/user']))
    }

    if(store.getters['auth/token'] && !to.meta.standalone) {
      let user = store.getters['auth/user']
      if(user.roles && user.roles.includes('User')) {
        to.meta.layout = 'app'
      }
    }
    
    if (store.state['auth']['user'] != null && store.state['auth']['user']['language'] !== null) {
      if (store.state['auth']['user']['language'] !== store.getters['lang/locale']) {
        // await setLocale(store.state['auth']['user']['language'])
      }
    }


    setLayout(router, to)
    next()
  })

  // Register after hook.
  router.afterEach((to, from) => {
    // router.app.$nextTick(() => {
    //   router.app.$loading.finish()
    // })
  })

  return router
}

/**
 * Add beforeEnter guard to the route.
 *
 * @param {Object} route
 * @param {Object}
 */
function beforeEnter (route) {
  if (route.children) {
    route.children.forEach(beforeEnter)
  }

  if (!route.middleware) {
    return route
  }

  route.beforeEnter = (...args) => {
    if (!Array.isArray(route.middleware)) {
      route.middleware = [route.middleware]
    }
    
    route.middleware.forEach(middleware => {
      if (typeof middleware === 'function') {
        middleware(...args)
      } else if (routeMiddleware[middleware]) {
        routeMiddleware[middleware](...args)
      } else {
        throw Error(`Undefined middleware [${middleware}]`)
      }
    })
  }

  return route
}

/**
 * Set the application layout from the matched page component.
 *
 * @param {Router} router
 * @param {Route} to
 */
async function setLayout (router, to) {
  const matched = router.resolve(to).matched
  if (!matched || matched.length === 0) {
    return
  }

  const route = matched[0] // Getting the matched route record
  if (!route || !route.components) {
    return
  }

  const component = route.components?.default // This is the actual component

  //to.meta.layout = 'app'
}

/**
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  }

  if (to.hash) {
    return { selector: to.hash }
  }

  const [route] = to.matched.slice(-1)
  if (route && route.components.default.scrollToTop === false) {
    return {}
  }

  return { x: 0, y: 0 }
}

/**
 * @param  {Object} requireContext
 * @return {Object}
 */
function resolveMiddleware (guardModules) {
  return Object.entries(guardModules).reduce((guards, [path, mod]) => {
    const name = path
      .replace('middleware/', '') // remove ./ and .js
      .replace(/^\.\/|\.js$/g, '') // remove ./ and .js
    guards[name] = mod.default
    return guards
  }, {})
}

async function resolveMatchedComponents(to) {
  const components = await Promise.all(
    to.matched.flatMap(record => {
      return Object.values(record.components).map(async comp => {
        // If it's an async function, resolve it
        if (typeof comp === 'function') {
          const loaded = await comp()
          return loaded
        }

        // If it's an async component from defineAsyncComponent
        if (comp.__asyncLoader) {
          const loaded = await comp.__asyncLoader()
          return loaded.default || loaded
        }

        return comp
      })
    })
  )

  return components
}





